export default __webpack_public_path__ + "assets/jpeg/qr_redirect_default.4c7d1f3fc4ba0483155f19378924ffbd.jpeg";